import { Link } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";

// Same public links (and labels) as the top navigation bar in App.js.
const QUICK_LINKS = [
  { to: "/", key: "nav.home" },
  { to: "/#gioi-thieu", key: "nav.about" },
  { to: "/catalog", key: "nav.products" },
  { to: "/news", key: "nav.news" },
  { to: "/gallery", key: "nav.gallery" },
  { to: "/#doi-tac", key: "nav.contact" },
];

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer mt-5 py-5">
      <div className="container">
        <footer className="site-footer">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="footer__logo d-flex align-items-center mb-4">
                <img src="/assets/img/logo.png" alt="Logo" width="80" height="80" />
                <div className="logo-text ms-3">
                  <small className='fs-6'>CÔNG TY THƯƠNG MẠI VÀ SẢN XUẤT</small> <br /> <span className="fw-bold">TINH ANH</span><br /><small>Since 2008</small>
                </div>
              </div>
              <p>Chuyên cung cấp thiết bị bếp, hệ thống hút khói, giải pháp toàn diện cho nhà hàng, khách sạn, resort, khu công nghiệp.</p>
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-start justify-content-md-center align-items-start">
              <div className='d-flex flex-column justify-content-center'>
                <h6>LIÊN KẾT NHANH</h6>
                <ul className="px-0">
                  {QUICK_LINKS.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to}>{t(l.key)}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-start justify-content-md-center align-items-start">
              <div className='d-flex flex-column justify-content-center'>
                <h6>SẢN PHẨM</h6>
                <ul className="px-0"><li>Bếp lẩu nướng</li><li>Bếp công nghiệp</li><li>Thiết bị nhà hàng</li><li>Hệ thống hút khói</li><li>Phụ kiện</li></ul>
              </div>
            </div>
            <div className="col-12 col-md-4 d-flex justify-content-start justify-content-md-center align-items-start">
              <div className='d-flex flex-column justify-content-center'>
                <h6>LIÊN HỆ</h6>
                <ul className="px-0"><li>📞 <a href="tel:+84352349198">0352 349 198</a></li><li>✉️ info@tinhanh.com</li><li>📍 270 Bạch Mai, Phường Bạch Mai, TP. Hà Nội</li></ul></div>
            </div>
          </div>

          <div className="copy mt-4"><span>© 2026 Tinh Anh. All rights reserved.</span></div>
        </footer>
      </div>
    </div>
  );
};

export default Footer;
